import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import {ContextProvider} from '../../components/ContextProvider/ContextProvider';
import {startEditingBasketItem, loadExistingBasketItem} from '../../actions/basketItem.action';
import {removeBasketItem, updateBasketItemQuantity, updateFulfillment, addItemStraightToBasket} from '../../actions/basket.action';
import {changeFormValue} from '../../actions/form.action';
import {BASKET_UUID_REGEX} from '../../constants/regex';
import {isIosPrivateMode} from '../../helpers/privateMode.helper';
import {ITEM_ORIGIN, ORDER_SOURCE, SERVICE_TYPE, URL_QUERY_PARAMS} from '../../constants/constant';
import {checkOpeningTime} from '../../helpers/date.helper';
import {sizes} from '../../styles/components/media-queries';
import MenuPageContent from './MenuPageContent';
import {setUpSellingModalCancelled} from '../../actions';
import {getUpSellingItems} from '../../helpers/upSellingHelper';
import {getUrlPath} from '../../helpers/url.helper';

export class MenuPage extends PureComponent {
  constructor(props) {
    super(props);
    this.upsellingItems = [];
    const params = new URLSearchParams(props.location.search.substring(1));
    const tableId = params.get(URL_QUERY_PARAMS.TABLE_ID);

    this.eatInTableId = tableId || null;
    this.state = {
      showDeliveryMinimumModal: false,
      showUpSellingModal: false,
      dataForPictureModal: null,
      iosPrivateModeModal: isIosPrivateMode(),
      showDisabledMealModal: false,
      tableId
    };
    this.handleShowMealModal = this.handleShowMealModal.bind(this);
    this.handleShowDisabledMealModal = this.handleShowDisabledMealModal.bind(this);
    this.handleHideDisabledMealModal = this.handleHideDisabledMealModal.bind(this);
    this.handleGoToCheckoutPage = this.handleGoToCheckoutPage.bind(this);
    this.addItemStraightToBasket = this.addItemStraightToBasket.bind(this);
    this.handleCloseDeliveryMinimumModal = this.handleCloseDeliveryMinimumModal.bind(this);
    this.handleOpenUpsellingModal = this.handleOpenUpsellingModal.bind(this);
    this.handleCloseUpSellingModal = this.handleCloseUpSellingModal.bind(this);
    this.handleOpenPictureModal = this.handleOpenPictureModal.bind(this);
    this.handleClosePictureModal = this.handleClosePictureModal.bind(this);
    this.clearTableId = this.clearTableId.bind(this);
  }

  componentDidMount() {
    if (window) {
      window.scrollTo(0, 0);
    }
    const {menu, location, orderSource, history} = this.props;
    const {tableId} = this.state;
    const params = new URLSearchParams(location.search.substring(1));
    const mealUuid = params.get(URL_QUERY_PARAMS.MEAL_UUID);
    let meal;
    if (mealUuid && mealUuid.match(BASKET_UUID_REGEX)) {
      meal = menu.meals[mealUuid];
      const origin = orderSource === ORDER_SOURCE.CENTRAL_DISH ? ITEM_ORIGIN.MENU : ITEM_ORIGIN.HOME;
      this.handleShowMealModal(meal, origin);
      const searchParams = tableId ? `?tableId=${tableId}` : '';
      // clear up the query params for the correct order origin
      history.push({
        pathname: '/menu',
        search: searchParams
      });
    }
  }

  handleShowMealModal(meal, origin) {
    this.props.startEditingBasketItem(meal, null, origin);
  }

  handleOpenDeliveryMinimumModal() {
    this.setState({showDeliveryMinimumModal: true});
  }

  handleCloseDeliveryMinimumModal() {
    this.setState({showDeliveryMinimumModal: false});
  }

  handleOpenPictureModal(dataForPictureModal) {
    this.setState({dataForPictureModal});
  }

  handleClosePictureModal() {
    this.setState({dataForPictureModal: null});
  }

  handleOpenUpsellingModal() {
    this.setState({showUpSellingModal: true});
  }

  handleCloseUpSellingModal() {
    const {setUpSellingModalCancelledFunc} = this.props;
    this.setState({showUpSellingModal: false});
    setUpSellingModalCancelledFunc(true);
  }

  handleShowDisabledMealModal(disabledDays) {
    this.setState({
      showDisabledMealModal: true,
      disabledMealDays: disabledDays
    });
  }

  handleHideDisabledMealModal() {
    this.setState({
      showDisabledMealModal: false,
      disabledMealDays: null
    });
  }

  handleGoToCheckoutPage(e) {
    if (e) {
      e.stopPropagation();
    }
    const {menu, upSellingModalCancelled, basket, restaurant, history} = this.props;
    const {showUpSellingModal} = this.state;
    this.upsellingItems = getUpSellingItems(menu.meals, menu.categories, basket.items);

    if (!upSellingModalCancelled && !showUpSellingModal && this.upsellingItems.length > 0 && restaurant.modes.upsellEnabled) {
      return this.handleOpenUpsellingModal();
    }
    this.handleCloseUpSellingModal();
    if (basket.fulfillment && basket.fulfillment.delivery && restaurant.deliverySettings && restaurant.deliverySettings.minimumAmount > basket.price.items) {
      this.handleOpenDeliveryMinimumModal();
    } else {
      const {checkoutForm, serviceTypeRadioButtons, changeFormValueFunc, updateFulfillmentFunc} = this.props;
      let delivery;
      let serviceType;
      const navToCheckoutUrl = getUrlPath(`/order/${basket.uuid}`, this.eatInTableId);

      if (restaurant.modes.collection && !restaurant.modes.delivery) {
        serviceType = SERVICE_TYPE.COLLECTION;
      } else if (!restaurant.modes.collection && restaurant.modes.delivery) {
        serviceType = SERVICE_TYPE.DELIVERY;
      } else if (serviceTypeRadioButtons) {
        serviceType = serviceTypeRadioButtons.values.serviceType;
      } else { // if there's no serviceTypeRadioButtons value means that it's mobile and the service type is already set
        history.push(navToCheckoutUrl);
        return;
      }
      // eat in
      if (this.eatInTableId) {
        serviceType = SERVICE_TYPE.COLLECTION;
      }
      if (checkoutForm) {
        delivery = {
          serviceType: serviceType,
          addressLine1: checkoutForm.values.addressLine1,
          addressLine2: checkoutForm.values.addressLine2,
          city: checkoutForm.values.city,
          postcode: checkoutForm.values.postcode
        };
      } else {
        delivery = {serviceType: serviceType};
      }
      changeFormValueFunc('checkoutForm', 'serviceType', serviceType);
      return updateFulfillmentFunc(basket.uuid, delivery)
        .then(() => history.push(navToCheckoutUrl));
    }
  }

  addItemStraightToBasket(item, origin) {
    const {restaurant, basket, addItemStraightToBasketFunc, orderSource} = this.props;
    return addItemStraightToBasketFunc(basket.uuid, restaurant.code, item, origin, orderSource);
  }

  clearTableId() {
    const {location, history} = this.props;
    const params = new URLSearchParams(location.search.substring(1));
    params.delete(URL_QUERY_PARAMS.TABLE_ID);
    history.push({
      pathname: '/menu',
      search: params.toString()
    });
    window.location.reload();
  }

  render() {
    const {
      basket,
      template,
      restaurant,
      isSideBasketLoading,
      loadExistingBasketItemFunc,
      removeBasketItemFunc,
      updateBasketItemQuantityFunc,
      updateFulfillmentFunc,
      changeFormValueFunc,
      serverOffline,
      resizeProps // see ResizeHandler.js
    } = this.props;

    const offlineMenu = this.props.match.params.offlineMenuId && this.props.offlineMenus.find(element => element.id === this.props.match.params.offlineMenuId);
    const menu = offlineMenu || this.props.menu;

    const openForDelivery = checkOpeningTime(restaurant.openingTimes.delivery) && restaurant.modes.delivery;
    const openForCollection = checkOpeningTime(restaurant.openingTimes.collection) && restaurant.modes.collection;
    const isMobile = resizeProps.windowWidth < sizes.small[resizeProps.orientation];
    const showSideBasket = restaurant.modes.onlineOrdering && !offlineMenu && !serverOffline;
    const showSideRestaurantClosed = !showSideBasket;
    const showServiceTypeModal = basket.items.length > 0 && !basket.fulfillment &&
      restaurant.modes.delivery && restaurant.modes.collection &&
      (openForDelivery && openForCollection || restaurant.modes.futureOrders);

    return (
      <MenuPageContent
        restaurant={restaurant}
        menu={menu}
        basket={basket}
        displayMenu={menu}
        offlineMenu={offlineMenu}
        openForDelivery={openForDelivery}
        openForCollection={openForCollection}
        iosPrivateModeModal={this.state.iosPrivateModeModal}
        isMobile={isMobile}
        isSideBasketLoading={isSideBasketLoading}
        showSideRestaurantClosed={showSideRestaurantClosed}
        showSideBasket={showSideBasket}
        showDeliveryMinimumModal={this.state.showDeliveryMinimumModal}
        showUpSellingModal={this.state.showUpSellingModal}
        showServiceTypeModal={showServiceTypeModal}
        removeBasketItemFunc={removeBasketItemFunc}
        updateBasketItemQuantityFunc={updateBasketItemQuantityFunc}
        updateFulfillmentFunc={updateFulfillmentFunc}
        changeFormValueFunc={changeFormValueFunc}
        handleShowMealModal={this.handleShowMealModal}
        addItemStraightToBasket={this.addItemStraightToBasket}
        handleOpenDeliveryMinimumModal={this.handleOpenDeliveryMinimumModal}
        handleCloseDeliveryMinimumModal={this.handleCloseDeliveryMinimumModal}
        handleCloseUpSellingModal={this.handleCloseUpSellingModal}
        handleGoToCheckoutPage={this.handleGoToCheckoutPage}
        loadExistingBasketItemFunc={loadExistingBasketItemFunc}
        showDisabledMealModal={this.state.showDisabledMealModal}
        handleShowDisabledMealModal={this.handleShowDisabledMealModal}
        handleHideDisabledMealModal={this.handleHideDisabledMealModal}
        handleOpenPictureModal = {this.handleOpenPictureModal}
        handleClosePictureModal = {this.handleClosePictureModal}
        dataForPictureModal={this.state.dataForPictureModal}
        disabledMealDays={this.state.disabledMealDays}
        serverOffline={serverOffline}
        upsellingItems={this.upsellingItems}
        isTemplateLight={template && template.name === 'light'}
        tableId={this.eatInTableId}
        clearTableId={this.clearTableId}
      />
    );
  }
}

MenuPage.propTypes = {
  startEditingBasketItem: PropTypes.func.isRequired,
  loadExistingBasketItemFunc: PropTypes.func.isRequired,
  removeBasketItemFunc: PropTypes.func.isRequired,
  updateBasketItemQuantityFunc: PropTypes.func.isRequired,
  addItemStraightToBasketFunc: PropTypes.func.isRequired,
  menu: PropTypes.object.isRequired,
  isSideBasketLoading: PropTypes.bool.isRequired,
  basket: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  restaurant: PropTypes.object.isRequired,
  updateFulfillmentFunc: PropTypes.func.isRequired,
  changeFormValueFunc: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  offlineMenus: PropTypes.array.isRequired,
  serviceTypeRadioButtons: PropTypes.object,
  checkoutForm: PropTypes.object,
  orderSource: PropTypes.string,
  resizeProps: PropTypes.object.isRequired,
  serverOffline: PropTypes.bool.isRequired,
  template: PropTypes.object.isRequired,
  setUpSellingModalCancelledFunc: PropTypes.func.isRequired,
  upSellingModalCancelled: PropTypes.bool.isRequired
};

const mapStateToProps = state => {
  return {
    language: state.language,
    template: state.template,
    isSideBasketLoading: state.loading.sideBasket,
    basket: state.basket,
    checkoutForm: state.form.checkoutForm,
    serviceTypeRadioButtons: state.form.serviceTypeRadioButtons,
    orderSource: state.orderSource,
    serverOffline: state.serverOffline,
    upSellingModalCancelled: state.upSelling.modalCancelled
  };
};

const mapDispatchToProps = dispatch => {
  return {
    startEditingBasketItem: bindActionCreators(startEditingBasketItem, dispatch),
    loadExistingBasketItemFunc: bindActionCreators(loadExistingBasketItem, dispatch),
    removeBasketItemFunc: bindActionCreators(removeBasketItem, dispatch),
    updateBasketItemQuantityFunc: bindActionCreators(updateBasketItemQuantity, dispatch),
    addItemStraightToBasketFunc: bindActionCreators(addItemStraightToBasket, dispatch),
    updateFulfillmentFunc: bindActionCreators(updateFulfillment, dispatch),
    changeFormValueFunc: bindActionCreators(changeFormValue, dispatch),
    setUpSellingModalCancelledFunc: bindActionCreators(setUpSellingModalCancelled, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ContextProvider(MenuPage));



// WEBPACK FOOTER //
// ./containers/MenuPage/MenuPage.js